// extracted by mini-css-extract-plugin
module.exports = {"pageHead":"pagehead-module--page-head--15Jtl","container":"pagehead-module--container--74-bB","content":"pagehead-module--content--1m4CU","text":"pagehead-module--text--10keC"};